import Content from '../atoms/Content';
import { Data } from '@models/index';
import { FunctionComponent } from 'react';
import Title from '../atoms/Title';

interface Props {
  data: Data;
}

const WelcomeSection: FunctionComponent<Props> = ({ data }) => {
  const { title, content, extraContent } = data;
  return (
    <div className="bg-white mt-20 min-h-fit w-11/12 p-5 rounded-lg my-5 verflow-y-scroll scrollbar scrollbar-thumb-blue-600 scrollbar-track-gray-50 scroll ">
      <Title title={title} />
      <div className="mt-12">
        <Content html={content} />
        <Content html={extraContent} />
      </div>
    </div>
  );
};

export default WelcomeSection;
